import React from "react";

const TickIcon = ({ size = 20, className = "text-primary-600", style }) => {
  return (
    <span className={className} style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.667"
          d="M16.665 5L7.5 14.167 3.332 10"
        ></path>
      </svg>
    </span>
  );
};

export const SingleTickIcon = ({ size = 20, className = "text-primary-600", style }) => {
  return (
    <span className={className} style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          d="M6.054 12.376a.63.63 0 00-.873 0 .588.588 0 000 .848l3.706 3.6a.63.63 0 00.873 0l9.06-8.8a.588.588 0 000-.848.63.63 0 00-.874 0l-8.622 8.376-3.27-3.176z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

export const DoubleTickIcon = ({ size = 20, className = "text-primary-600", style }) => {
  return (
    <span className={className} style={style}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <g stroke="currentColor" strokeLinecap="round" strokeMiterlimit={10}>
          <path d="m7.2 11.299.21.162a1 1 0 0 0 1.323-.093L14.4 5.6M1.6 9.803l2.033 1.623a1 1 0 0 0 1.35-.095L10.4 5.6" />
        </g>
      </svg>
    </span>
  );
};

export default TickIcon;